<template>
  <div>
    <v-menu
      v-model="open"
      :close-on-content-click="false"
      offset-y
      content-class="notification-drawer--menu"
      transition="slide-y-reverse-transition"
      origin="center center"
      nudge-bottom="8"
      nudge-right="16"
      left
    >
      <template #activator="{ on }">
        <div class="lh-1" v-on="on">
          <slot />
        </div>
      </template>

      <v-card
        v-if="open"
        class="notification-drawer d-flex flex-column"
        color="grey600"
      >
        <v-card-title class="d-flex align-center justify-space-between grey500 py-3">
          <h4 class="text-body-2" v-text="$tc('common.notification', notifications.length)" />
          <a
            v-show="!!notifications.length"
            class="link text-caption text--secondary"
            @click="$emit('dismiss-all')"
          >
            <fai :icon="['fal', 'check-double']" class="mr-1" />
            <span v-text="$t('cta.dismiss_all')" />
          </a>
        </v-card-title>

        <v-card-text v-if="notifications.length" class="notifications pa-0">
          <v-list class="pa-0" color="grey600" three-line>
            <transition-group name="scroll-x-transition">
              <template v-for="(notification, index) in notifications">
                <NotificationItem
                  :key="notification.id"
                  :notification="notification"
                  @dismiss="$emit('dismiss', $event)"
                />

                <v-divider
                  v-if="index < notifications.length - 1"
                  :key="index"
                />
              </template>
            </transition-group>
          </v-list>
        </v-card-text>
        <v-card-text v-else class="pa-6 d-flex flex-grow-1 align-center justify-center">
          <div class="text-center">
            <fai :icon="['fal', 'bells']" class="text-h3 grey200--text mb-3 mt-n2" />
            <h4 class="text-subtitle-2 lh-1-2" v-text="$t('layout.notifications.empty.title')" />
            <p class="text-caption mb-0" v-text="$t('layout.notifications.empty.subtitle')" />
          </div>
        </v-card-text>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import NotificationItem from '@/components/NotificationItem'

export default {
  components: {
    NotificationItem,
  },
  props: {
    notifications: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      open: false,
    }
  },
  computed: {},
}
</script>

<style lang="scss" scoped>
.notification-drawer--menu {
  min-width: 380px !important;
  max-width: 380px !important;
  max-height: unset !important;

  @include xs {
    min-width: 94% !important;
  }
}

.notification-drawer {
  min-height: 250px;
  max-height: 350px;

  .notifications {
    overflow-x: hidden;
    overflow-y: auto;

    .notification-item.scroll-x-transition-move {
      transition: all 0.3s ease;
    }
  }
}
</style>
